<!-- eslint-disable -->
<template>

    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Редактирование атрибута</h3>
                        <div class="card-toolbar">
                        </div>
                    </div>
                    <div class="card-body">
                        <div v-if="load" class="text-center mb-10">
                            <b-spinner variant="primary" label="Text Centered"></b-spinner>
                        </div>
                        <div v-else >
                            <b-form-group class="mb-1"
                                          description="Введите название атрибута"
                                          label="Заголовок:"
                            >
                                <b-form-input
                                        v-model.trim="attribute.name"
                                        :class="{'is-invalid': errors.name}"
                                        required
                                ></b-form-input>
                                <div v-if="errors.name" class="invalid-feedback">{{errors.name[0]}}</div>
                            </b-form-group>

                            <b-form-group class=" mb-4"
                                          description="Выберите вид опций для вариативных товаров"
                                          label="Тип опций"
                            >
                                <b-form-select v-model="attribute.type" :class="{'is-invalid': errors.type}">

                                    <option value="default">По умолчанию</option>
                                    <option value="color">Цвет</option>


                                </b-form-select>
                                <div v-if="errors.type" class="invalid-feedback">{{errors.type[0]}}</div>
                            </b-form-group>

                            <h3 class="card-title font-weight-bolder text-dark">Опции атрибута:</h3>


                            <!--begin::Table-->
                            <div class="table-responsive mt-2 mb-2">
                                <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_4">
                                    <thead>
                                    <tr class="text-left">
                                        <th class="pl-0">Название</th>
                                        <th>Вид</th>
                                        <th class="pr-0 text-right">Действия</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-for="option in attribute.options">
                                        <tr>
                                            <td class="pl-0">
                                                <div class="d-flex align-items-center">
                                                    <b-link @click="editOption(option)" class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">
                                                        {{option.name}}
                                                    </b-link>
                                                </div>
                                            </td>
                                            <td>
                                                <span class="text-muted font-weight-bold">
                                                    <b-button
                                                            @click="editOption(option)"
                                                            v-if="attribute.type === 'color'"
                                                            :style="{backgroundColor: option.color} "
                                                            style="min-width: 25px; min-height: 25px;"
                                                            size="sm" class="mr-2">
                                                    </b-button>
                                                </span>
                                            </td>

                                            <td class="pr-0 text-right">
                                                <b-link v-b-tooltip.hover title="Редактировать опцию" @click="editOption(option)" class="btn btn-icon btn-light btn-hover-primary btn-sm"><i class="fas fa-edit"></i></b-link>
                                                <b-link @click="showModalOption(option)" v-b-tooltip.hover title="Удалить опцию" class="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"><i class="fas fa-trash-alt"></i></b-link>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>

                            <b-button @click="showAddOption" class="mb-10" ref="add_option" block variant="success">Добавить опцию</b-button>

                            <!--end::Table-->
                            <div class="d-flex justify-content-between">
                                <b-button @click="saveAttribute" ref="save_attribute" variant="primary">Сохранить атрибут</b-button>
                                <b-button @click="showModal" type="submit" variant="outline-danger">Удалить атрибут</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal ref="add-option-modal" centered hide-footer title="Добавить опцию">
            <div class="d-block">

                <b-form-group
                              description="Введите название опции"
                              label="Название опции:"
                >
                    <b-form-input
                            v-model.trim="new_option.name"
                            :class="{'is-invalid': errorsOption.name}"
                            required
                    ></b-form-input>
                    <div v-if="errorsOption.name" class="invalid-feedback">{{errorsOption.name[0]}}</div>
                </b-form-group>

                <b-form-group v-if="attribute.type === 'color'"
                              description="Выберите цвет"
                              label="Цвет опции"
                >
                    <b-form-input
                            v-model="new_option.color"
                            :class="{'is-invalid': errorsOption.color}"
                            type="color"
                    ></b-form-input>
                    <div v-if="errorsOption.color" class="invalid-feedback">{{errorsOption.name[0]}}</div>
                </b-form-group>

            </div>

            <b-button ref="add_option" class="mt-3" variant="outline-primary" block @click="AddOption">Создать</b-button>

        </b-modal>

        <b-modal ref="edit-option-modal" centered hide-footer title="Редактировать опцию">
            <div class="d-block">

                <b-form-group
                              description="Введите название опции"
                              label="Название опции:"
                >
                    <b-form-input
                            v-model.trim="edit_option.name"
                            :class="{'is-invalid': errorsOption.name}"
                            required
                    ></b-form-input>
                    <div v-if="errorsOption.name" class="invalid-feedback">{{errorsOption.name[0]}}</div>
                </b-form-group>

                <b-form-group v-if="attribute.type === 'color'"
                              description="Выберите цвет"
                              label="Цвет опции"
                >
                    <b-form-input
                            v-model="edit_option.color"
                            :class="{'is-invalid': errorsOption.color}"
                            type="color"
                    ></b-form-input>
                    <div v-if="errorsOption.color" class="invalid-feedback">{{errorsOption.name[0]}}</div>
                </b-form-group>

            </div>

            <b-button ref="save_option" class="mt-3" variant="outline-primary" block @click="saveOption">Сохранить</b-button>

        </b-modal>


        <b-modal ref="delete-modal" centered hide-footer hide-header title="Подтвердите действие">
            <div class="d-block text-center">
                <h3>Удалить атрибут?</h3>

                <div role="alert" class="alert alert-warning alert-dismissible text-dark text-center">
                    <strong><i class="fa fa-info-circle"></i> Внимание!</strong>
                    <br>При удаление атрибута вы удаляете его из всех товаров.
                    <br>Убедитесь в отсутствии вариации с этим атрибутом
                </div>

            </div>
            <b-row>
                <b-col>
                    <b-button class="mt-3" variant="outline-primary" block @click="hideModal">Отмена</b-button>
                </b-col>
                <b-col>
                    <b-button ref="delete_attribute" class="mt-3" variant="outline-danger" block @click="deleteAttribute">Удалить</b-button>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal ref="delete-option" centered hide-footer hide-header title="Подтвердите действие">
            <div class="d-block text-center">
                <h3>Удалить опцию: {{del_option.name}}?</h3>

                <div role="alert" class="alert alert-warning alert-dismissible text-dark text-center">
                    <strong><i class="fa fa-info-circle"></i> Внимание!</strong>
                    <br>При удаление опции вы удаляете его из всех товаров.
                    <br>Убедитесь в отсутствии вариации с этой опцией
                </div>

            </div>
            <b-row>
                <b-col>
                    <b-button class="mt-3" variant="outline-primary" block @click="hideModalOption">Отмена</b-button>
                </b-col>
                <b-col>
                    <b-button class="mt-3" variant="outline-danger" block @click="deleteOption">Удалить</b-button>
                </b-col>
            </b-row>
        </b-modal>


        <b-modal ref="delete-attribute-fail" centered hide-footer title="Сообщение">
            <div class="d-block text-center">
                <h3>Невозможно удалить атрибут</h3>

                <div role="alert" class="alert alert-danger alert-dismissible text-white">
                    <strong><i class="fa fa-info-circle"></i> Внимание!</strong>
                    <br>Имеются вариации с этим атрибутом в следующих товарах:
                </div>



                <div class="table-responsive mt-2 mb-2">
                    <table class="table table-head-custom table-vertical-center">
                        <thead>
                        <tr class="text-left">
                            <th class="pl-0">Заголовок</th>
                            <th class="pr-0 text-right">Действия</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="product in productsAttribute">
                                <td class="pl-0">
                                    <div class="d-flex align-items-center">
                                        <div class="symbol symbol-50 flex-shrink-0 mr-4">
                                            <div class="symbol-label"
                                                 :style="{ backgroundImage: 'url(' + $urlBackEnd(product.images[0].thumbnail) + ')' }">
                                            </div>
                                        </div>

                                        <div>
                                            <router-link :to="{ name: 'FormProduct', params: {action: 'edit', id: product.id}}" class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{product.title}}</router-link>
                                            <span class="text-muted font-weight-bold d-block"> {{product.stock}} шт.</span>
                                        </div>
                                    </div>
                                </td>
                                <td class="pr-0 text-right">
                                    <router-link :to="{ name: 'FormProduct', params: {action: 'edit', id: product.id}}" v-b-tooltip.hover title="Редактировать товар" class="btn btn-icon btn-light btn-hover-primary btn-sm"><i class="fas fa-edit"></i></router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <small>Показано не более 20 товаров</small>

            </div>

            <b-button class="mt-3" variant="primary" block @click="hideModalDelAttributeFail">Закрыть</b-button>

        </b-modal>


        <b-modal ref="delete-option-fail" centered hide-footer title="Сообщение">
            <div class="d-block text-center">
                <h3>Невозможно удалить опцию</h3>

                <div role="alert" class="alert alert-danger alert-dismissible text-white">
                    <strong><i class="fa fa-info-circle"></i> Внимание!</strong>
                    <br>Имеются вариации с этой опцией в следующих товарах:
                </div>

                <div class="table-responsive mt-2 mb-2">
                    <table class="table table-head-custom table-vertical-center">
                        <thead>
                        <tr class="text-left">
                            <th class="pl-0">Заголовок</th>
                            <th class="pr-0 text-right">Действия</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="product in productsOption">
                            <td class="pl-0">
                                <div class="d-flex align-items-center">
                                    <div class="symbol symbol-50 flex-shrink-0 mr-4">
                                        <div class="symbol-label"
                                             :style="{ backgroundImage: 'url(' + $urlBackEnd(product.images[0].thumbnail) + ')' }">
                                        </div>
                                    </div>

                                    <div>
                                        <router-link :to="{ name: 'FormProduct', params: {action: 'edit', id: product.id}}" class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{product.title}}</router-link>
                                        <span class="text-muted font-weight-bold d-block"> {{product.stock}} шт.</span>
                                    </div>
                                </div>
                            </td>
                            <td class="pr-0 text-right">
                                <router-link :to="{ name: 'FormProduct', params: {action: 'edit', id: product.id}}" v-b-tooltip.hover title="Редактировать товар" class="btn btn-icon btn-light btn-hover-primary btn-sm"><i class="fas fa-edit"></i></router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <small>Показано не более 20 товаров</small>

            </div>

            <b-button class="mt-3" variant="primary" block @click="hideModalDelOptionFail">Закрыть</b-button>

        </b-modal>



    </div>
</template>

<script>

    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {SET_ALERT} from "@/core/services/store/alert.module";

    import {DELETE_ATTRIBUTE, GET_ATTRIBUTE, UPDATE_ATTRIBUTE} from "../../../core/services/store/attributes.module";
    import {
        ADD_ATTRIBUTE_OPTION,
        DELETE_ATTRIBUTE_OPTION,
        UPDATE_ATTRIBUTE_OPTION
    } from "../../../core/services/store/attributesOptions.module";

    export default {
        name: "EditAttribute",

        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                { title: "Атрибуты", route: "/attributes" },
                { title: "Редактирование атрибута" }
            ]);

            this.$store.dispatch(GET_ATTRIBUTE, this.$route.params.id);
        },

        computed: {
            ...mapGetters({
                attribute: 'gettersAttribute',
                errors: 'errorsAttribute',
                errorsOption: 'errorsAttributeOption',
                load: 'getAttributeLoad',
            }),
        },

        data(){
            return{

                productsAttribute:[],
                productsOption:[],

                clear_option: {
                    id: '',
                    attribute_id: '',
                    name: '',
                    option: '',
                    color: '#7461d1',
                },

                edit_option: {
                    id: '',
                    attribute_id: '',
                    name: '',
                    option: '',
                    color: '',
                },

                new_option: {
                    id: '',
                    attribute_id: '',
                    name: '',
                    option: '',
                    color: '#7461d1',
                },

                del_option: {
                    id: '',
                    attribute_id: '',
                    name: '',
                    option: '',
                    color: '',
                }
            }
        },

        methods:{
            saveAttribute(){
                const submitButton = this.$refs["save_attribute"];
                submitButton.classList.add("spinner", "spinner-light", "spinner-right");

                const id = this.attribute.id;
                const attribute = {
                    name: this.attribute.name,
                    type: this.attribute.type,
                };

                this.$store.dispatch(UPDATE_ATTRIBUTE, {id, attribute})
                    .then(() => {
                        this.showAlert('Атрибут успешно сохранен', 'success');
                        this.$router.push({ name: "Attributes" })

                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                        }
                    })
                    .finally(() => {
                        submitButton.classList.remove("spinner", "spinner-light", "spinner-right")
                    });
            },


            deleteAttribute(){

                const submitButton = this.$refs["delete_attribute"];
                submitButton.classList.add("spinner", "spinner-light", "spinner-right");


                this.$store.dispatch(DELETE_ATTRIBUTE, this.attribute.id)
                    .then(() => {
                        this.$router.push({ name: "Attributes" })
                        this.showAlert('Атрибут успешно удален', 'success');
                    })
                    .catch((response) => {
                        if (response.status === 403 && response.data.products.length > 0){
                            this.showAlert('Невозможно удалить. Имеются вариации с данным атрибутом', 'danger', 'toast');
                            this.productsAttribute = response.data.products;
                            this.$refs['delete-attribute-fail'].show()
                        } else {
                            this.showAlert('Ошибка удаления. Код ошибки: ' + response.status, 'danger', 'toast');
                        }
                    })
                    .finally(() => {
                        this.hideModal()
                        submitButton.classList.remove("spinner", "spinner-light", "spinner-right")
                    })
            },


            hideModalDelAttributeFail(){
                this.$refs['delete-attribute-fail'].hide()
            },


            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },


            showAddOption() {
                this.new_option = this.clear_option;
                this.$refs['add-option-modal'].show()
            },

            AddOption() {

                const submitButtonOption = this.$refs["add_option"];
                submitButtonOption.classList.add("spinner", "spinner-light", "spinner-right");

                const option = {
                    attribute: this.attribute.id,
                    name: this.new_option.name
                };

                this.$store.dispatch(ADD_ATTRIBUTE_OPTION, option)
                    .then(() => {
                        this.showAlert('Опция успешно добавлена', 'success', 'toast');
                        this.$store.dispatch(GET_ATTRIBUTE, option.attribute);
                        this.$refs['add-option-modal'].hide();
                        this.new_option = this.clear_option
                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                        }
                    })
                    .finally(() => {
                        submitButtonOption.classList.remove("spinner", "spinner-light", "spinner-right")
                    })
            },


            editOption(option){

                this.edit_option = option;
                this.$refs['edit-option-modal'].show()

            },

            saveOption(){
                const submitButtonOptionSave = this.$refs["save_option"];
                submitButtonOptionSave.classList.add("spinner", "spinner-light", "spinner-right");

                this.$store.dispatch(UPDATE_ATTRIBUTE_OPTION, this.edit_option)
                    .then(() => {
                        this.showAlert('Опция успешно сохранена', 'success', 'toast');
                        this.$store.dispatch(GET_ATTRIBUTE, this.edit_option.attribute_id);
                        this.$refs['edit-option-modal'].hide();
                        this.edit_option = this.clear_option
                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                        }
                    })
                    .finally(() => {
                        submitButtonOptionSave.classList.remove("spinner", "spinner-light", "spinner-right")
                    })

            },

            showModal() {
                this.$refs['delete-modal'].show()
            },

            hideModal() {
                this.$refs['delete-modal'].hide()
            },

            showModalOption(option){
                this.del_option  = option;
                this.$refs['delete-option'].show()
            },

            hideModalOption(){
                this.$refs['delete-option'].hide()
            },

            deleteOption(){
                this.$store.dispatch(DELETE_ATTRIBUTE_OPTION, {option: this.del_option.id, attribute: this.attribute.id})
                    .then(() => {
                        this.showAlert('Опция успешно удалена', 'success', 'toast');
                        this.$store.dispatch(GET_ATTRIBUTE, this.$route.params.id);
                        this.del_option = this.clear_option
                    })
                    .catch((response) => {
                        if (response.status === 403 && response.data.products.length > 0){
                            this.showAlert('Невозможно удалить. Имеются вариации с данной опцией', 'danger', 'toast');
                            this.productsOption = response.data.products;
                            this.$refs['delete-option-fail'].show()
                        } else {
                            this.showAlert('Ошибка удаления. Код ошибки: ' + response.status, 'danger', 'toast');
                        }
                    })
                    .finally(() => {
                        this.hideModalOption();
                    })

            },

            hideModalDelOptionFail(){
                this.$refs['delete-option-fail'].hide()
            },

        }
    }
</script>

<style scoped>

</style>